import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { IMAGES } from "../images/images"
import { Phone, Package, Truck, Building2, Trash2, CheckCircle, Clock, Shield, Star, ArrowRight, MapPin, ChevronDown } from "lucide-react";
import { trackPhoneConversion } from "../utils/tracking";


const PHONE = "+359876995651";
// const HERO_IMG = "../images/heroHome.avif";

const faqs = [
  {
    q: "Колко струва преместване с хамали в София?",
    a: "Цената зависи от обема на вещите, етажа, разстоянието и необходимия брой хамали. Обаждате се, описвате ситуацията и ние ви даваме точна оферта — безплатно и без ангажимент.",
  },
  {
    q: "Колко бързо можете да дойдете?",
    a: "В много случаи можем да организираме идване още в деня на обаждането. Препоръчваме предварително уговаряне за по-голяма гъвкавост, но при спешност — обадете се и ще намерим решение.",
  },
  {
    q: "Работите ли в почивни дни и официални празници?",
    a: "Да, работим 7 дни в седмицата от 7:00 до 22:00, включително събота, неделя и официални празници. Можем да се съобразим с вашия график.",
  },
  {
    q: "Включва ли услугата разглобяване и сглобяване на мебели?",
    a: "Да. При необходимост разглобяваме мебели — гардероби, легла, кухненски елементи и ги сглобяваме на новото място. Уточнете при записването.",
  },
  {
    q: "Нужно ли е предварително записване?",
    a: "Записването е препоръчително, за да гарантираме наличност в желания ден и час. При спешни случаи се свържете директно с нас — ще направим всичко възможно да ви помогнем веднага.",
  },
  {
    q: "Какви транспортни средства използвате?",
    a: "Разполагаме с микробуси и камиони с падащ борд за тежки и габаритни товари. Изборът на подходящото превозно средство зависи от обема на вещите — съветваме ви при записването.",
  },
  {
    q: "Обслужвате ли само София или и областта?",
    a: "Обслужваме цяла София и всички квартали, както и София-областта. При нужда от превоз до по-отдалечено населено място — обадете се за уточняване.",
  },
  {
    q: "Как се уверявам, че вещите ми са в безопасност?",
    a: "Нашите хамали са опитни и работят с необходимото оборудване — опаковъчни материали, предпазни одеяла и колички. Отнасяме се с вашите вещи с пълно внимание и отговорност.",
  },
];

const reviews = [
  {
    name: "Мартин Георгиев",
    service: "Преместване на апартамент",
    text: "Страхотна работа! Момчетата дойдоха навреме, наредиха всичко внимателно и за 3 часа бяхме готови. Определено ще ги препоръчам на приятели.",
  },
  {
    name: "Елена Стоянова",
    service: "Почистване на мазе",
    text: "Имахме пълно мазе с вещи от 20 години. За половин ден всичко беше изнесено и извозено. Много съм доволна от резултата и от отношението!",
  },
  {
    name: "Николай Петров",
    service: "Преместване на офис",
    text: "Преместихме целия офис за един ден без никакви проблеми. Техниката и мебелите пристигнаха в перфектно състояние. Много професионален екип.",
  },
];

const sofiaAreas = [
  "Банкя", "Бели брег", "Борово", "Бояна", "Братя Миладинови", "Витоша",
  "Връбница", "Гео Милев", "Горна баня", "Дианабад", "Дружба", "Захарна фабрика",
  "Изгрев", "Илинден", "Искър", "Иван Вазов", "Княжево", "Красна поляна",
  "Красно село", "Лагера", "Левски", "Лозенец", "Люлин", "Малинова долина",
  "Младост", "Надежда", "Обеля", "Овча купел", "Оборище", "Орландовци",
  "Павлово", "Панчарево", "Подуяне", "Сердика", "Слатина", "Средец",
  "Студентски", "Сухата река", "Триадица", "Факултета", "Хаджи Димитър",
  "Хладилника", "Христо Ботев", "Яворов",
];

const services = [
  { icon: Package, title: "Хамалски услуги", desc: "Пренасяне на мебели, уреди и тежки предмети от опитен екип. Безопасно и бързо.", link: "/hamalski-uslugi", testId: "service-card-hamalski" },
  { icon: Truck, title: "Транспортни услуги", desc: "Разполагаме с бусове и камиони за всякакъв вид превоз в София и областта.", link: "/transportni-uslugi", testId: "service-card-transport" },
  { icon: Building2, title: "Преместване на офиси", desc: "Бързо и сигурно преместване на офис оборудване без прекъсване на работния процес.", link: "/ofis-hamali", testId: "service-card-ofis" },
  { icon: Trash2, title: "Почистване", desc: "Изчистване на мазета, тавани и гаражи. Извозване на стари мебели до сметище.", link: "/pochistvane", testId: "service-card-pochist" },
];

const whyUs = [
  { icon: CheckCircle, title: "Безплатен оглед", desc: "Изпращаме специалист за безплатна оценка и точна оферта без ангажимент." },
  { icon: Clock, title: "Гъвкав график", desc: "Работим 7 дни в седмицата, включително почивни дни и официални празници." },
  { icon: Shield, title: "Надеждност и сигурност", desc: "Вашите вещи са в безопасни ръце — работим внимателно и отговорно." },
  { icon: Star, title: "Опит и професионализъм", desc: "Многогодишен опит в хамалски услуги и преместване в Столичния район." },
];

const stats = [
  { value: "500+", label: "Доволни клиента" },
  { value: "8+", label: "Години опит" },
  { value: "7/7", label: "Дни работим" },
  { value: "100%", label: "Безплатен оглед" },
];

function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div
      style={{
        backgroundColor: "#FFFFFF",
        border: "1px solid rgba(0,0,0,0.08)",
        borderRadius: "8px",
        overflow: "hidden",
        boxShadow: "0 1px 8px rgba(0,0,0,0.04)",
        transition: "box-shadow 0.2s ease",
      }}
    >
      <button
        onClick={() => setOpen(!open)}
        data-testid="faq-toggle"
        style={{
          width: "100%", textAlign: "left",
          display: "flex", alignItems: "center", justifyContent: "space-between",
          gap: "1rem",
          padding: "1.25rem 1.5rem",
          background: "none", border: "none", cursor: "pointer",
        }}
      >
        <span style={{ fontFamily: "Montserrat, sans-serif", fontWeight: 700, fontSize: "clamp(0.9rem, 2.5vw, 1rem)", color: "#0A0A0A", lineHeight: 1.4 }}>
          {q}
        </span>
        <ChevronDown
          size={20}
          color="#2dcf0c"
          style={{ flexShrink: 0, transition: "transform 0.25s ease", transform: open ? "rotate(180deg)" : "rotate(0deg)" }}
        />
      </button>
      {open && (
        <div style={{ padding: "0 1.5rem 1.25rem" }}>
          <p style={{ color: "#6B7280", fontSize: "0.925rem", lineHeight: 1.75, margin: 0 }}>{a}</p>
        </div>
      )}
    </div>
  );
}

function FaqList({ faqs }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "0.625rem" }}>
      {faqs.map((faq, i) => (
        <FaqItem key={i} q={faq.q} a={faq.a} />
      ))}
    </div>
  );
}

export default function HomePage() {
  useEffect(() => {
    document.title = "Хамали София | Хамалски услуги — Бързо, Сигурно и Изгодно";
    const setMeta = (name, content, property = false) => {
      const attr = property ? "property" : "name";
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute(attr, name); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    const setCanonical = (url) => {
      let el = document.querySelector('link[rel="canonical"]');
      if (!el) { el = document.createElement("link"); el.setAttribute("rel", "canonical"); document.head.appendChild(el); }
      el.setAttribute("href", url);
    };
    setMeta("description", "Хамали София — професионални хамалски услуги, преместване на мебели, транспорт и почистване на мазета в цяла София. Обадете се за безплатна оферта: +359 876 995 651");
    setMeta("og:title", "Хамали София | Хамалски услуги — Бързо, Сигурно и Изгодно", true);
    setMeta("og:description", "Пренасяне на мебели, транспорт, офис преместване и почистване в цяла София. Работим 7 дни в седмицата. Безплатен оглед.", true);
    setMeta("og:url", "https://hamalski-sofia.com/", true);
    setCanonical("https://hamalski-sofia.com/");
  }, []);

  return (
    <div style={{ backgroundColor: "#FFFFFF" }}>

      {/* HERO — stays dark */}
      <section data-testid="hero-section" style={{ position: "relative", minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", textAlign: "center", overflow: "hidden" }}>
        <div style={{ position: "absolute", inset: 0, backgroundImage: `url(${IMAGES.HeroHome})`, backgroundSize: "cover", backgroundPosition: "center" }} />
        <div className="hero-overlay" />
        <div style={{ position: "relative", zIndex: 2, maxWidth: "900px", margin: "0 auto", padding: "7rem 1.25rem 5rem" }}>
          <div style={{ display: "inline-flex", alignItems: "center", gap: "0.5rem", backgroundColor: "rgba(45,207,12,0.12)", border: "1px solid rgba(45,207,12,0.3)", borderRadius: "100px", padding: "0.35rem 1rem", marginBottom: "1.5rem", fontSize: "0.8rem", color: "#2dcf0c", fontFamily: "Manrope, sans-serif", fontWeight: 600, letterSpacing: "0.06em", textTransform: "uppercase" }}>
            <span style={{ width: 6, height: 6, borderRadius: "50%", backgroundColor: "#2dcf0c", flexShrink: 0 }} />
            Обслужваме София и София-област
          </div>
          <h1 data-testid="hero-h1" style={{ fontFamily: "Montserrat, sans-serif", fontWeight: 900, fontSize: "clamp(2.5rem, 8vw, 5.5rem)", lineHeight: 1.05, letterSpacing: "-0.02em", color: "#FFFFFF", marginBottom: "1.25rem", textTransform: "uppercase" }}>
            Хамали и Хамалски Услуги в{" "}
            <span style={{ color: "#2dcf0c" }}>София</span>
          </h1>
          <p data-testid="hero-subtitle" style={{ fontSize: "clamp(1rem, 2.5vw, 1.2rem)", color: "#d4d4d8", lineHeight: 1.7, marginBottom: "2rem", maxWidth: "640px", margin: "0 auto 2rem" }}>
            Бързо, сигурно и изгодно пренасяне на мебели и багаж. Транспорт, преместване на офиси и почистване на мазета — обаждате се, ние пристигаме!
          </p>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "1rem", justifyContent: "center" }}>
            <a href={`tel:${PHONE}`} data-testid="hero-call-btn" className="btn-call" style={{ padding: "1rem 2.25rem", fontSize: "1.05rem", borderRadius: "4px" }} onClick={trackPhoneConversion}>
              <Phone size={20} />
              <span>Обадете се</span>
            </a>
            <Link to="/hamalski-uslugi" data-testid="hero-services-link" style={{ display: "inline-flex", alignItems: "center", gap: "0.5rem", padding: "1rem 2rem", border: "2px solid rgba(255,255,255,0.25)", color: "#FFFFFF", textDecoration: "none", fontSize: "1rem", fontFamily: "Montserrat, sans-serif", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.04em", borderRadius: "4px", transition: "border-color 0.2s ease, background-color 0.2s ease" }}
              onMouseEnter={(e) => { e.currentTarget.style.borderColor = "rgba(255,255,255,0.6)"; e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.05)"; }}
              onMouseLeave={(e) => { e.currentTarget.style.borderColor = "rgba(255,255,255,0.25)"; e.currentTarget.style.backgroundColor = "transparent"; }}>
              <span>Вижте услугите</span>
              <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </section>

      {/* STATS BAR — light */}
      <section data-testid="stats-section" style={{ backgroundColor: "#FFFFFF", borderBottom: "1px solid rgba(0,0,0,0.07)" }}>
        <div style={{ maxWidth: "1280px", margin: "0 auto", padding: "2.5rem 1.25rem" }}>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))", gap: "1.5rem" }}>
            {stats.map((s) => (
              <div key={s.label} style={{ textAlign: "center" }}>
                <div style={{ fontFamily: "Montserrat, sans-serif", fontWeight: 900, fontSize: "2.5rem", color: "#2dcf0c", lineHeight: 1, marginBottom: "0.3rem" }}>{s.value}</div>
                <div style={{ color: "#6B7280", fontSize: "0.825rem", fontWeight: 600 }}>{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SERVICES GRID — light grey bg */}
      <section data-testid="services-section" style={{ padding: "5rem 1.25rem", backgroundColor: "#F8F8FA" }}>
        <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: "3rem" }}>
            <p style={{ color: "#2dcf0c", fontSize: "0.8rem", fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: "0.75rem" }}>Нашите услуги</p>
            <h2 data-testid="services-heading" style={{ fontFamily: "Montserrat, sans-serif", fontWeight: 900, fontSize: "clamp(1.75rem, 4vw, 2.75rem)", color: "#0A0A0A", textTransform: "uppercase", letterSpacing: "-0.02em", marginBottom: "1rem" }}>Какво предлагаме</h2>
            <p style={{ color: "#6B7280", fontSize: "1rem", maxWidth: "500px", margin: "0 auto" }}>Пълен набор от хамалски и транспортни услуги за дома и офиса в цял ден.</p>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: "1.25rem" }}>
            {services.map((s) => {
              const Icon = s.icon;
              return (
                <Link key={s.link} to={s.link} data-testid={s.testId} className="service-card" style={{ display: "block", padding: "2rem", backgroundColor: "#FFFFFF", border: "1px solid rgba(0,0,0,0.08)", textDecoration: "none", borderRadius: "8px", boxShadow: "0 2px 16px rgba(0,0,0,0.05)" }}>
                  <div className="service-icon" style={{ marginBottom: "1.25rem", transition: "color 0.25s ease" }}>
                    <Icon size={36} color="#71717A" />
                  </div>
                  <h3 className="service-title" style={{ fontFamily: "Montserrat, sans-serif", fontWeight: 800, fontSize: "1.1rem", color: "#0A0A0A", textTransform: "uppercase", letterSpacing: "-0.01em", marginBottom: "0.75rem", transition: "color 0.25s ease" }}>{s.title}</h3>
                  <p style={{ color: "#6B7280", fontSize: "0.9rem", lineHeight: 1.65, marginBottom: "1.25rem" }}>{s.desc}</p>
                  <span style={{ display: "inline-flex", alignItems: "center", gap: "0.4rem", color: "#2dcf0c", fontSize: "0.85rem", fontWeight: 700, fontFamily: "Manrope, sans-serif" }}>
                    Научи повече <ArrowRight size={14} />
                  </span>
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      {/* WHY US — white */}
      <section data-testid="why-us-section" style={{ borderTop: "1px solid rgba(0,0,0,0.06)", padding: "5rem 1.25rem", backgroundColor: "#FFFFFF" }}>
        <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "3rem", alignItems: "center" }}>
            <div className="img-zoom" style={{ borderRadius: "8px", overflow: "hidden", minHeight: "350px", boxShadow: "0 4px 30px rgba(0,0,0,0.12)" }}>
              <img src={IMAGES.Home1} alt="Хамали пренасят кашони" style={{ width: "100%", height: "100%", objectFit: "cover", minHeight: "350px" }} loading="lazy"/>
            </div>
            <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
              <p style={{ color: "#2dcf0c", fontSize: "0.8rem", fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: "0.75rem" }}>Защо да изберете нас</p>
              <h2 style={{ fontFamily: "Montserrat, sans-serif", fontWeight: 900, fontSize: "clamp(1.75rem, 3.5vw, 2.5rem)", color: "#0A0A0A", textTransform: "uppercase", letterSpacing: "-0.02em", marginBottom: "2rem" }}>
                Хамали София — Доверен партньор в София
              </h2>
              <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
                {whyUs.map((item) => {
                  const Icon = item.icon;
                  return (
                    <div key={item.title} className="feature-item" style={{ display: "flex", alignItems: "flex-start", gap: "1rem" }} data-testid={`why-us-${item.title.toLowerCase().replace(/\s+/g, '-')}`}>
                      <div style={{ width: 40, height: 40, flexShrink: 0, backgroundColor: "rgba(45,207,12,0.08)", border: "1px solid rgba(45,207,12,0.2)", borderRadius: "4px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <Icon size={18} color="#2dcf0c" />
                      </div>
                      <div>
                        <h4 style={{ fontFamily: "Montserrat, sans-serif", fontWeight: 700, fontSize: "0.95rem", color: "#0A0A0A", marginBottom: "0.25rem" }}>{item.title}</h4>
                        <p style={{ color: "#6B7280", fontSize: "0.875rem", lineHeight: 1.6 }}>{item.desc}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* REVIEWS */}
      <section
        data-testid="reviews-section"
        style={{ padding: "5rem 1.25rem", backgroundColor: "#F8F8FA", borderTop: "1px solid rgba(0,0,0,0.06)" }}
      >
        <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: "3rem" }}>
            <p style={{ color: "#2dcf0c", fontSize: "0.8rem", fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: "0.75rem" }}>
              Отзиви
            </p>
            <h2 style={{ fontFamily: "Montserrat, sans-serif", fontWeight: 900, fontSize: "clamp(1.75rem, 4vw, 2.5rem)", color: "#0A0A0A", textTransform: "uppercase", letterSpacing: "-0.02em" }}>
              Какво казват <span style={{ color: "#2dcf0c" }}>нашите клиенти</span>
            </h2>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: "1.25rem" }}>
            {reviews.map((r, i) => (
              <div
                key={i}
                data-testid={`review-card-${i}`}
                style={{
                  padding: "1.75rem",
                  backgroundColor: "#FFFFFF",
                  border: "1px solid rgba(0,0,0,0.08)",
                  borderRadius: "8px",
                  boxShadow: "0 2px 16px rgba(0,0,0,0.05)",
                  display: "flex",
                  flexDirection: "column",
                  gap: "1rem",
                }}
              >
                <div style={{ display: "flex", gap: "2px" }}>
                  {[...Array(5)].map((_, s) => (
                    <Star key={s} size={16} fill="#2dcf0c" color="#2dcf0c" />
                  ))}
                </div>
                <p style={{ color: "#374151", fontSize: "0.925rem", lineHeight: 1.7, fontStyle: "italic", margin: 0, flexGrow: 1 }}>
                  "{r.text}"
                </p>
                <div style={{ display: "flex", alignItems: "center", gap: "0.75rem", paddingTop: "0.5rem", borderTop: "1px solid rgba(0,0,0,0.06)" }}>
                  <div style={{
                    width: 38, height: 38, borderRadius: "50%",
                    backgroundColor: "rgba(45,207,12,0.1)",
                    border: "1px solid rgba(45,207,12,0.25)",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    fontFamily: "Montserrat, sans-serif", fontWeight: 800,
                    fontSize: "0.85rem", color: "#2dcf0c", flexShrink: 0,
                  }}>
                    {r.name[0]}
                  </div>
                  <div>
                    <p style={{ fontFamily: "Montserrat, sans-serif", fontWeight: 700, fontSize: "0.875rem", color: "#0A0A0A", margin: 0 }}>{r.name}</p>
                    <p style={{ fontSize: "0.775rem", color: "#9CA3AF", margin: 0 }}>{r.service}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SERVICE AREAS */}
      <section
        data-testid="areas-section"
        style={{ padding: "5rem 1.25rem", backgroundColor: "#FFFFFF", borderTop: "1px solid rgba(0,0,0,0.06)" }}
      >
        <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: "2.5rem" }}>
            <p style={{ color: "#2dcf0c", fontSize: "0.8rem", fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: "0.75rem" }}>
              Работна зона
            </p>
            <h2 style={{ fontFamily: "Montserrat, sans-serif", fontWeight: 900, fontSize: "clamp(1.75rem, 4vw, 2.5rem)", color: "#0A0A0A", textTransform: "uppercase", letterSpacing: "-0.02em", marginBottom: "0.875rem" }}>
              Обслужваме всички райони в <span style={{ color: "#2dcf0c" }}>София</span>
            </h2>
            <p style={{ color: "#6B7280", fontSize: "1rem", maxWidth: "520px", margin: "0 auto" }}>
              Хамали София работи във всеки квартал на столицата и в цялата София-област.
            </p>
          </div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem", justifyContent: "center" }}>
            {sofiaAreas.map((area) => (
              <span
                key={area}
                style={{
                  display: "inline-flex", alignItems: "center", gap: "0.3rem",
                  padding: "0.4rem 0.875rem",
                  backgroundColor: "#F8F8FA",
                  border: "1px solid rgba(0,0,0,0.08)",
                  borderRadius: "100px",
                  fontSize: "0.85rem",
                  color: "#374151",
                  fontFamily: "Manrope, sans-serif",
                  fontWeight: 500,
                }}
              >
                <MapPin size={11} color="#2dcf0c" />
                {area}
              </span>
            ))}
          </div>
          <p style={{ textAlign: "center", marginTop: "2rem", color: "#9CA3AF", fontSize: "0.85rem" }}>
            Не виждате вашия квартал?{" "}
            <a href={`tel:${PHONE}`} style={{ color: "#2dcf0c", fontWeight: 700, textDecoration: "none" }} onClick={trackPhoneConversion}>
              Обадете се
            </a>{" "}
            — обслужваме и цялата София-област.
          </p>
        </div>
      </section>

      {/* FAQ */}
      <section
        data-testid="faq-section"
        style={{ padding: "5rem 1.25rem", backgroundColor: "#F8F8FA", borderTop: "1px solid rgba(0,0,0,0.06)" }}
      >
        <div style={{ maxWidth: "820px", margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: "3rem" }}>
            <p style={{ color: "#2dcf0c", fontSize: "0.8rem", fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: "0.75rem" }}>
              Често задавани въпроси
            </p>
            <h2 style={{ fontFamily: "Montserrat, sans-serif", fontWeight: 900, fontSize: "clamp(1.75rem, 4vw, 2.5rem)", color: "#0A0A0A", textTransform: "uppercase", letterSpacing: "-0.02em" }}>
              Имате въпроси?
            </h2>
          </div>
          <FaqList faqs={faqs} phone={PHONE} />
        </div>
      </section>

      {/* CTA STRIP — light green tint */}
      <section data-testid="cta-strip" style={{ padding: "5rem 1.25rem", textAlign: "center", backgroundColor: "#F0FDF4", borderTop: "1px solid rgba(45,207,12,0.2)", borderBottom: "1px solid rgba(45,207,12,0.2)" }}>
        <div style={{ maxWidth: "700px", margin: "0 auto" }}>
          <h2 style={{ fontFamily: "Montserrat, sans-serif", fontWeight: 900, fontSize: "clamp(1.75rem, 4vw, 3rem)", color: "#0A0A0A", textTransform: "uppercase", letterSpacing: "-0.02em", marginBottom: "1rem" }}>
            Нужни са ви хамали?{" "}
            <span style={{ color: "#2dcf0c" }}>Обадете се сега!</span>
          </h2>
          <p style={{ color: "#6B7280", fontSize: "1rem", marginBottom: "2rem" }}>
            Безплатна консултация и оценка на цената. Работим всеки ден от 7:00 до 22:00.
          </p>
          <a href={`tel:${PHONE}`} data-testid="cta-strip-call-btn" className="btn-call" style={{ padding: "1.1rem 2.5rem", fontSize: "1.1rem", borderRadius: "4px" }} onClick={trackPhoneConversion}>
            <Phone size={22} />
            <span>Обадете се</span>
          </a>
        </div>
      </section>
    </div>
  );
}
